module.exports = __webpack_public_path__ + "img/night-map.png";